// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cls-1[data-v-4bc4ed12],.cls-2[data-v-4bc4ed12]{opacity:.95}.cls-1[data-v-4bc4ed12]{fill:url(#logo-gradient-1)}.cls-2[data-v-4bc4ed12]{fill:url(#logo-gradient-2)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
